module.exports = __webpack_public_path__ + "media/images/button_sign-up-a4359555cf648fa0d150302011bcd8c3.svg";